<template>
  <div
    id="nowData"
    style="text-align: center"
    :class="{ dark: !$store.state.isdark }"
  >
  
    <div id="circle">
      <i-circle
        :stroke-color="['#ff3350', '#fbca60']"
        :trail-color="$store.state.isdark ? '#eee' : '#333'"
        :percent="(data[curentPoint].speed / 140) * 100"
        dashboard
        :size="160"
      >
        <span class="demo-circle-inner" style="font-size: 40px">{{
          data[curentPoint].speed
        }}</span>
        <p style="margin: 4px auto 16px auto">km/h</p>
        <p>{{ data[curentPoint].mileage }}km</p>
        <p id="now_mileage">
          {{ (data[curentPoint].mileage - data[0].mileage).toFixed(2) }}km
        </p>
      </i-circle>
    </div>
    <p>{{ utils.time(data[curentPoint].gpsTime) }}</p>

    <div
      span="24"
      class="icon-guiji"
      v-if="$store.state.control"
      v-show="!$store.state.isPrint"
    >
      <!-- <Icon
        @click="setDriver"
        :type="isDriver ? 'md-car' : 'md-speedometer'"
        title="驾驶/普通模式"
        v-if="jiandan==undefined"
      /> -->
      <Icon @click="removeSpeed" type="md-remove" title="减速" />
      <Icon
        @click="submit"
        :type="playMol == 2 ? 'ios-play' : 'ios-pause'"
        title="播放/暂停"
      />
      <Icon @click="addSpeed" type="md-add" title="加速" />
      <!-- <Icon
        @click="dark"
        :type="$store.state.isdark ? 'md-moon' : 'md-sunny'"
        title="夜间/白天"
        v-if="jiandan==undefined"
      /> -->
    </div>
    <p>
      {{ address }}
    </p>
    <div>
      <Slider
        v-model="speed"
        :min="0"
        :max="100"
        style="width: 100%"
        @on-change="changeSlider"
      ></Slider>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "curentPoint", "openList", "openSpeedTime","jiandan"],
  data() {
    return {
      deal: false,
      quxian1: false,
      model1: "5",
      speed: 0, //车辆速度
      speedList: [
        {
          value: "1",
          label: "一档",
        },
        {
          value: "5",
          label: "二档",
        },
        {
          value: "10",
          label: "三档",
        },
        {
          value: "15",
          label: "四档",
        },
        {
          value: "20",
          label: "五档",
        },
      ],
      playMol: 2,
      dangwei: 6,
      address: "暂停可查看地址",
      isDriver: false,
    };
  },
  methods: {
    addSpeed() {
      if (this.dangwei == 31) {
        this.$Message.error("已经是最高速度");
        return;
      }

      this.dangwei += 5;
      this.$emit("changeSpeed", this.dangwei);
    },
    removeSpeed() {
      if (this.dangwei == 1) {
        this.$Message.error("已经是最低速度");
        return;
      }
      this.dangwei -= 5;
      this.$emit("changeSpeed", this.dangwei);
    },
    //点击播放按钮
    submit() {
      if (this.data.length == 1) {
        this.$Message.error("只有一个轨迹点，不需要播放");
        return;
      }
      if (this.playMol == 2) {
        this.playMol = 3;
        this.$store.state.carMsg.play = 3;
        this.address = "暂停可查看地址";
      } else if (this.playMol == 3) {
        this.playMol = 2;
        this.$store.state.carMsg.play = 2;
        var pointList = [
          {
            x: this.data[this.curentPoint].locateLng,
            y: this.data[this.curentPoint].locateLat,
          },
        ];
        this.utils.jiexi(pointList).then((data) => {
          this.address = data[0].address;
        });
      }
      this.$emit("parentFn", this.playMol);
    },
    //点击速度选择
    changeSpeed(v) {},
    //拖动滑块时候
    changeSlider(v) {
      this.$emit("changeSlider", v);
    },
    //车辆移动时候滑块改变
    changeCurentPoint(v, length) {
      //console.log(v);
      this.speed = Number((v * 100) / (length - 1));
    },
    //白天黑夜
    dark() {
      this.$store.state.isdark = !this.$store.state.isdark;
      this.$emit("dark");
    },
    setDriver() {
      this.isdriver = !this.isdriver;
      this.$emit("jiashi", this.isdriver);
    },
    upDown() {
      this.isDown = !this.isDown;
    },
    reset() {
      this.$store.state.carMsg.play = 2;
      this.speed = 0;
    },
  },
  watch: {
    openList(v) {
      this.deal = v;
    },
    openSpeedTime(v) {
      this.quxian1 = v;
    },
  },
  mounted() {
    var pointList = [
      {
        x: this.data[0].locateLng,
        y: this.data[0].locateLat,
      },
    ];
    this.utils.jiexi(pointList).then((data) => {
      this.address = data[0].address;
      
    });
  },
};
</script>
<style lang="">
#nowData {
  background: #fff;
  padding: 20px 15px 4px 15px;
  z-index: 200;
  color: #333;
  width: 240px;
  overflow: hidden;
}

#now_mileage {
  font-size: 20px;
  background: #fa8424;
  color: #fff;
  width: 100px;
  margin: auto;
  margin-bottom: -30px;
  margin-top: 4px;
  line-height: 24px;
  position: relative;
}
#now_mileage::before {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: 0;
  left: -16px;
  border-right: 16px solid #fa8424;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}
#now_mileage::after {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: 0;
  right: -16px;
  border-left: 16px solid #fa8424;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.icon-guiji {
  margin-top: 20px;
  margin-bottom: 20px;
}

.icon-guiji i {
  font-size: 22px;
  padding: 0.3em;
  margin: 0 2px;
  border-radius: 1em;
  color: #fff;
  background: #fa8424;
  opacity: 1;
}
.icon-guiji i:hover {
  opacity: 0.8;
  cursor: pointer;
}
#nowData .ivu-slider-bar {
  background: #fa8424;
}
#nowData #jiupian {
  width: 60px;
  height: 24px;
  background: #fa8424;
  color: #fff;
  margin: -10px auto 15px auto;
  border-radius: 20px;
  cursor: pointer;
}

#nowData #jiupian i {
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  margin-top: 8px;
}
#nowData #jpbtn {
  width: 100%;
  z-index: 200;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/nowData.vue